import { PasswordRequirementsText } from './enums/password-requirements';

export const passwordRequirements = [
  PasswordRequirementsText.passwordLength,
  PasswordRequirementsText.uniqueCharacters,
  PasswordRequirementsText.passwordsMustMatch,
  PasswordRequirementsText.newPasswordNotDifferent,
  PasswordRequirementsText.commonPassword
];
